import {
  ACADEMY_CATEGORY_CATEGORY_PAGE,
  CONNECTIONS_STEPSLUG_PAGE,
  JOBS_PROFILE_PAGE,
  ONBOARDING_V3_STEPSLUG_PAGE,
  WAR_ROOM_POSTS_TAB_PAGE,
  WAR_ROOM_POSTS_TAB_TAB_PAGE,
} from './pages_generated';
import type { RouteConst } from './types/pages';
import { DEFAULT_ACADEMY_TOPIC } from '~/components/partials/academy/constants';

// expanded pages for pages with params
export const ONBOARDING_V3_EXPECTATIONS_PAGE = { ...ONBOARDING_V3_STEPSLUG_PAGE, params: { stepSlug: 'expectations' } };
export const ONBOARDING_V3_JOB_SEARCH_PAGE = { ...ONBOARDING_V3_STEPSLUG_PAGE, params: { stepSlug: 'job-search' } };
export const ONBOARDING_V3_ABOUTYOU_PAGE = { ...ONBOARDING_V3_STEPSLUG_PAGE, params: { stepSlug: 'profile' } };
export const WAR_ROOM_POSTS_TAB_MYFEED_PAGE = {
  ...WAR_ROOM_POSTS_TAB_TAB_PAGE,
  params: { tab: 'my_feed' },
  path: '/war-room/posts/tab/my_feed',
};
export const WAR_ROOM_POSTS_TAB: RouteConst = {
  ...WAR_ROOM_POSTS_TAB_PAGE,
  path: '/war-room/posts/tab',
};
export const CONNECTIONS_SYNC_PAGE = { ...CONNECTIONS_STEPSLUG_PAGE, params: { stepSlug: 'sync' } };
export const CONNECTIONS_CONTACT_PAGE = { ...CONNECTIONS_STEPSLUG_PAGE, params: { stepSlug: 'contacts' } };
export const ACADEMY_All_ARTICLES_PAGE = {
  ...ACADEMY_CATEGORY_CATEGORY_PAGE,
  params: { category: DEFAULT_ACADEMY_TOPIC.slug },
};

export const POSTS_PAGE: RouteConst = {
  path: '/war-room/posts',
  name: 'war-room-posts',
};

export const JOBS_CANDIDATE_PROFILE_PAGE: RouteConst = {
  path: '/jobs/profile',
  name: JOBS_PROFILE_PAGE.name,
};

/**
 * Pages for back compatibility, because they gone by redirects
 */
export const WAR_ROOM_PAGE = WAR_ROOM_POSTS_TAB_MYFEED_PAGE;

/**
 * Whenever you need link to portfolio you should use /p/ instead of /portfolio/
 * if you need to generate path or url to portfolio, please use helpers from here
 * frontend/utils/routes.ts
 */
export const PORTFOLIO_PAGE_PATH = '/p/';

export const TECH_SALES_U_LANDING = 'https://learn.bravado.co/techsalesu';

export * from './pages_generated';
